<template>
  <div :class="['vc-sketch', disableAlpha ? 'vc-sketch__disable-alpha' : '']" @keydown.stop @keyup.stop @keypress.stop>
    <div class="vc-sketch-saturation-wrap">
      <saturation v-model="colors" @change="childChange"></saturation>
    </div>
    <div class="vc-sketch-controls">
      <div class="vc-sketch-sliders">
        <div class="vc-sketch-hue-wrap">
          <hue v-model="colors" @change="childChange"></hue>
        </div>
        <div class="vc-sketch-alpha-wrap" v-if="!disableAlpha">
          <alpha v-model="colors" @change="childChange"></alpha>
        </div>
      </div>
      <div class="vc-sketch-color-wrap">
        <div class="vc-sketch-active-color" :style="{background: activeColor}"></div>
        <checkboard></checkboard>
      </div>
    </div>
    <!--<div class="vc-sketch-field" v-if="!disableFields">

      <div class="vc-sketch-field--double">
        <ed-in label="hex" :value="hex" @change="inputChange"></ed-in>
      </div>
      <div class="vc-sketch-field--single">
        <ed-in label="r" :value="colors.rgba.r" @change="inputChange"></ed-in>
      </div>
      <div class="vc-sketch-field--single">
        <ed-in label="g" :value="colors.rgba.g" @change="inputChange"></ed-in>
      </div>
      <div class="vc-sketch-field--single">
        <ed-in label="b" :value="colors.rgba.b" @change="inputChange"></ed-in>
      </div>
      <div class="vc-sketch-field--single" v-if="!disableAlpha">
        <ed-in label="a" :value="colors.a" :arrow-offset="0.01" :max="1" @change="inputChange"></ed-in>
      </div>
    </div>-->
    <div class="vc-chrome-fields-wrap" v-if="!disableFields">
        <div class="vc-chrome-eyedropper" v-show="hasEyedropper">
          <el-tooltip effect="dark" placement="top" content="取色器">
          <i
            class="icon-eyedropper"
            @click.stop="eyedropperStart"
            @mousedown.stop
            ref="eyedropperBtn"
          ></i>
          </el-tooltip>
        </div>

      <div class="vc-chrome-fields" v-show="fieldsIndex === 0">
        <!-- hex -->
        <div class="vc-chrome-field">
          <ed-in label="hex" :value="colors.hex" @change="inputChange"></ed-in>
        </div>
      </div>
      <div class="vc-chrome-fields" v-show="fieldsIndex === 1">
        <!-- rgba -->
        <div class="vc-chrome-field">
          <ed-in label="r" :value="colors.rgba.r" @change="inputChange"></ed-in>
        </div>
        <div class="vc-chrome-field">
          <ed-in label="g" :value="colors.rgba.g" @change="inputChange"></ed-in>
        </div>
        <div class="vc-chrome-field">
          <ed-in label="b" :value="colors.rgba.b" @change="inputChange"></ed-in>
        </div>
        <div class="vc-chrome-field" v-if="!disableAlpha">
          <ed-in label="a" :value="colors.a" :arrow-offset="0.01" :max="1" @change="inputChange"></ed-in>
        </div>
      </div>
      <div class="vc-chrome-fields" v-show="fieldsIndex === 2">
        <!-- hsla -->
        <div class="vc-chrome-field">
          <ed-in label="h" :value="hsl.h" @change="inputChange"></ed-in>
        </div>
        <div class="vc-chrome-field">
          <ed-in label="s" :value="hsl.s" @change="inputChange"></ed-in>
        </div>
        <div class="vc-chrome-field">
          <ed-in label="l" :value="hsl.l" @change="inputChange"></ed-in>
        </div>
        <div class="vc-chrome-field" v-if="!disableAlpha">
          <ed-in label="a" :value="colors.a" :arrow-offset="0.01" :max="1" @change="inputChange"></ed-in>
        </div>
      </div>
      <!-- btn -->
      <div class="vc-chrome-toggle-btn" @click="toggleViews">
        <div class="vc-chrome-toggle-icon">
          <svg style="width:24px; height:24px" viewBox="0 0 24 24"
            @mouseover="showHighlight"
            @mouseenter="showHighlight"
            @mouseout="hideHighlight"
          >
            <path fill="#333" d="M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" />
          </svg>
        </div>
        <div class="vc-chrome-toggle-icon-highlight" v-show="highlight"></div>
      </div>
      <!-- btn -->
    </div>

    <div class="vc-sketch-presets">
      <div class="vc-sketch-presets-color"
        v-for="c in presetColors"
        :key="c"
        :class="c === 'none' && 'vc-preset-color-none'"
        :style="{background: c}"
        @click="handlePreset(c)">
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alpha,
  Checkboard,
  EditableInput,
  Hue,
  Saturation,
  ColorMixin
} from 'vue-color';

const presetColors = [
  '#FFFFFF', '#CDD9DD', '#AFBFC5', '#76919A', '#35484F', '#000000',
  '#1289E2', '#6BB9F0', '#00C952', '#FFEA01', '#FE6B0E', '#FF1943',
]

export default {
  name: 'Sketch',
  mixins: [ColorMixin],
  components: {
    Alpha,
    Checkboard,
    'ed-in': EditableInput,
    Hue,
    Saturation,
  },
  props: {
    presetColors: {
      type: Array,
      default () {
        return presetColors
      }
    },
    disableAlpha: {
      type: Boolean,
      default: true
    },
    mouse: {
      type: Boolean,
      default: false
    },
    disableFields: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      fields: ['hex', 'rgba', 'hsla'],
      fieldsIndex: 1,
      highlight: true,
      hasEyedropper: true
    }
  },
  computed: {
    hex () {
      return this.colors.hex.replace('#', '')
    },
    hsl () {
      const { h, s, l } = this.colors.hsl
      return {
        h: h.toFixed(),
        s: `${(s * 100).toFixed()}%`,
        l: `${(l * 100).toFixed()}%`
      }
    },
    activeColor () {
      var rgba = this.colors.rgba
      return 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')'
    }
  },
  methods: {
    handlePreset (c) {
      if (c === 'none') {
        this.$emit('colorNone', 'none');
        return;
      }
      this.colorChange({
        hex: c,
        source: 'hex'
      })
    },
    childChange (data) {
      this.colorChange(data)
    },
    inputChange (data) {
      if (!data) {
        return
      }
      if (data.hex) {
        this.isValidHex(data.hex) && this.colorChange({
          hex: data.hex,
          source: 'hex'
        })
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        })
      }
    },
    toggleViews () {
      if (this.fieldsIndex >= 2) {
        this.fieldsIndex = this.colors.a < 1 ? 1 : 0
        return
      }
      this.fieldsIndex ++
    },
    showHighlight () {
      // this.highlight = true
    },
    hideHighlight () {
      // this.highlight = false
    },
    eyedropperStart () {
      if (this.$refs.eyedropperBtn.classList.contains('el-icon-loading')) {
        return;
      }
      this.$emit('eyedropper-start');
    },
    eyedropperWaitingStart () {
      this.$refs.eyedropperBtn.classList.remove('icon-eyedropper');
      this.$refs.eyedropperBtn.classList.add('el-icon-loading');
    },
    eyedropperWaitingEnd () {
      this.$refs.eyedropperBtn.classList.remove('el-icon-loading');
      this.$refs.eyedropperBtn.classList.add('icon-eyedropper');
    },
    toggleEyedropper (flag) {
      this.hasEyedropper = flag;
    }
  }
}
</script>

<style lang="scss">
.vc-sketch {
  position: relative;
  width: 180px;
  padding: 10px 10px 0;
  box-sizing: initial;
  /* background: #fff; */
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15);
}
.vc-sketch-saturation-wrap {
  width: 100%;
  padding-bottom: 75%;
  position: relative;
  overflow: hidden;
}
.vc-sketch-controls {
  display: flex;
}
.vc-sketch-sliders {
  padding: 4px 0;
  flex: 1;
}
.vc-sketch-sliders .vc-hue,
.vc-sketch-sliders .vc-alpha-gradient {
  border-radius: 2px;
}
.vc-sketch-hue-wrap {
  position: relative;
  height: 10px;
}
.vc-sketch-alpha-wrap {
  position: relative;
  height: 10px;
  margin-top: 4px;
  overflow: hidden;
}
.vc-sketch-color-wrap {
  width: 24px;
  height: 24px;
  position: relative;
  margin-top: 4px;
  margin-left: 4px;
  border-radius: 3px;
}
.vc-sketch-active-color {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25);
  z-index: 2;
}
.vc-sketch-color-wrap .vc-checkerboard {
  background-size: auto;
}

.vc-sketch-field {
  display: flex;
  padding-top: 4px;
}
.vc-sketch-field .vc-input__input {
  width: 80%;
  padding: 4px 10% 3px;
  border: none;
  box-shadow: inset 0 0 0 1px #ccc;
  font-size: 11px;
}
.vc-sketch-field .vc-input__label {
  display: block;
  text-align: center;
  font-size: 11px;
  color: #222;
  padding-top: 3px;
  padding-bottom: 4px;
  text-transform: capitalize;
}
.vc-sketch-field--single {
  flex: 1;
  padding-left: 6px;
}
.vc-sketch-field--double {
  flex: 2;
}
.vc-sketch-presets {
  display: flex;
  flex-wrap: wrap;
  width: 180px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 10px;
  border-top: 1px solid #eee;
}
.vc-sketch-presets-color {
  /* border-radius: 3px; */
  overflow: hidden;
  position: relative;
  display: inline-block;
  /* margin: 0 10px 10px 0; */
  vertical-align: top;
  cursor: pointer;
  width: 30px;
  height: 30px;
  /* box-shadow: inset 0 0 0 1px rgba(0,0,0,.15); */
}

.vc-sketch__disable-alpha .vc-sketch-color-wrap {
  height: 10px;
}
// vc-chrome-fields
.vc-chrome-fields-wrap {
  display: flex;
  padding-top: 16px;
}
.vc-chrome-fields {
  display: flex;
  margin-left: -6px;
  flex: 1;
}
.vc-chrome-field {
  padding-left: 6px;
  width: 100%;
}
.vc-chrome-toggle-btn {
  width: 32px;
  text-align: right;
  position: relative;
}
.vc-chrome-toggle-icon {
  margin-right: -4px;
  margin-top: 12px;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.vc-chrome-toggle-icon-highlight {
  position: absolute;
  width: 24px;
  height: 28px;
  background: #fff;
  border-radius: 4px;
  top: 10px;
  left: 12px;
}
.vc-chrome-hue-wrap {
  position: relative;
  height: 10px;
  margin-bottom: 8px;
}
.vc-chrome-alpha-wrap {
  position: relative;
  height: 10px;
}
.vc-chrome-hue-wrap .vc-hue {
  border-radius: 2px;
}
.vc-chrome-alpha-wrap .vc-alpha-gradient {
  border-radius: 2px;
}
.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  transform: translate(-6px, -2px);
  background-color: rgb(248, 248, 248);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.vc-chrome-body {
  padding: 16px 16px 12px;
  background-color: #fff;
}
.vc-chrome-saturation-wrap {
  width: 100%;
  padding-bottom: 55%;
  position: relative;
  border-radius: 2px 2px 0 0;
  overflow: hidden;
}
.vc-chrome-saturation-wrap .vc-saturation-circle {
  width: 12px;
  height: 12px;
}

.vc-chrome-fields .vc-input__input {
  font-size: 11px;
  color: #333;
  width: 100%;
  border-radius: 2px;
  border: none;
  box-shadow: inset 0 0 0 1px #dadada;
  height: 21px;
  text-align: center;
}
.vc-chrome-fields .vc-input__label {
  text-transform: uppercase;
  font-size: 11px;
  line-height: 11px;
  color: #969696;
  text-align: center;
  display: block;
  margin-top: 12px;
}

.vc-chrome__disable-alpha .vc-chrome-active-color {
  width: 18px;
  height: 18px;
}
.vc-chrome__disable-alpha .vc-chrome-color-wrap {
  width: 30px;
}
.vc-chrome__disable-alpha .vc-chrome-hue-wrap {
  margin-top: 4px;
  margin-bottom: 4px;
}

.vc-chrome-eyedropper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 10px;
  width: 24px;
}
.vc-chrome-eyedropper > i {
  cursor: pointer;
}

.vc-preset-color-none {
  background-color: #fff !important;
  overflow: hidden;
  &:before {
    content: " ";
    position: absolute;
    height: 1px;
    width: 110px;
    background-color: red;
    transform: rotate(-45deg) translatex(-79px) translatey(-29px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/content/colorPickerSketch.vue